// extracted by mini-css-extract-plugin
module.exports = {"customerCard":"customersimplified_customerCard__2jzQF","selectIcon":"customersimplified_selectIcon__2lAAD","overlay":"customersimplified_overlay__14qH_"};